<template>
  <div>
    <div v-if='mp4ClipDone' class="flex flex-col">
      <video class="h-64 object-contain" controls muted loop autoplay :key='clip.mp4Url'>
        <source :src='makeClipUrl(clip.mp4Url)' type="video/mp4">
      </video>
    </div>
    <div v-else class="h-64 relative">
      <div :style='busyStyle' class="absolute left-0 top-0 right-0 bottom-0 opacity-50" />
      <div class="mx-auto px-6 pt-12 w-full h-64 relative">
        <p class="my-auto text-gray-300 text-lg">Busy recording clip.</p>
        <p class="my-auto text-white text-3xl py-2 font-bold">{{clip.progress}}%</p>
        <p class="my-auto text-white text-lg">{{clip.status}}</p>
        <p class="my-auto text-white font-thin">It may take up to a minute to prepare your clip.</p>
      </div>
      <fill-loader />
    </div>

    <div class="my-1 w-full md:max-w-sm h-12 flex flex-row mt-4 mb-2 flex flex-row self-center justify-center">
      <a v-if='hasGifUrl' class="border-white border pbc-button grow flex flex-row bg-gray-800 text-white justify-between"
          :href='makeClipUrl(clip.gifUrl)'
          target='_blank'
          :download='clip.gifUrl'
          @click='onClickGif'
          >
        <div class="flex flex-row">
          <download-circle-outline />
          <span>GIF</span>
        </div>
        <span class="clip-size-label">{{makeSize(clip.gifSize)}}</span>
      </a>
      <div v-else class='pbc-button text-gray-400 grow bg-gray-500 flex flex-row'>
        <loader v-if='mp4ClipDone' class="ml-4 mt-2 mr-4"/>
        <div v-if='mp4ClipDone'>
          <p class="text-white text-lg font-bold">{{clip.progress}}%</p>
          <p class="text-white">{{clip.status}}</p>
        </div>
        <div v-else class="flex flex-row">
          <download-circle-outline />
          <span>GIF</span>
        </div>
      </div>
      <a v-if='hasMp4Url' class="border-white border pbc-button grow bg-gray-800 text-white flex flex-row justify-between"
          :href='makeClipUrl(clip.mp4Url)'
          @click='onClickMp4'
          target='_blank'
          :download='clip.mp4Url'
        >
        <div class="flex flex-row">
        <download-circle-outline />
        <span>MP4</span>
        </div>
        <p class="clip-size-label">{{makeSize(clip.mp4Size)}}</p>
      </a>
      <div v-else class='pbc-button text-gray-400 grow bg-gray-500 flex flex-row'>
        <download-circle-outline />
        <span>MP4</span>
      </div>

    </div>

  </div>
</template>
<script>
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

import DownloadCircleOutline from '@icons/DownloadCircleOutline.vue';
export default {
  inject:['api'],
  props:{
    clip:{
      type:Object,
      required:true
    },
    postId:{
      type:String,
      default:''
    }
  },
  components:{
    DownloadCircleOutline
  },
  methods:{
    onClickGif() {
      console.log('click gif');
      this.$ana.track({
        eventCategory:'download',
        eventAction:'gif',
        extra:{
          id:this.postId
        }
      });
    },
    onClickMp4() {
      console.log('click mp4');
      this.$ana.track({
        eventCategory:'download',
        eventAction:'mp4',
        extra:{
          id:this.postId
        }
      });
    },
    makeClipUrl(url) {
      if (!url) {
        return this.api.makeImageUrlEditor('placeholder.png');
      }
      return this.api.makeClipUrl(url);
    },
    makeSize(size) {
      if (!size) {
        return '';
      }
      return formatBytes(size)
    },

  },
  computed:{
    busyStyle() {
      if (this.clip.thumbnail) {
        const backgroundUrl = this.api.makeThumbnailUrlEditor(this.clip.thumbnail);
        return {
          'background-image':`url(${backgroundUrl})`,
          'background-repeat':'no-repeat',
          'background-size':'contain',
          'background-position':'center'
        }
      }
      return {}
    },
    hasMp4Url() {
      return ((this.clip||{}).mp4Url||'').length > 0
    },
    hasGifUrl() {
      return ((this.clip||{}).gifUrl||'').length > 0
    },
    mp4ClipDone() {
      return this.clip.status === 'recorded' || this.hasMp4Url;
    },
  }
}
</script>
